import { Button, Form, Input, Select, Space } from 'antd';
import React from 'react';
import {
  COMENTARIOS_ADICIONALES_ANULACION,
  MOTIVO_ANULACION_SELECT,
  OTROS_MOTIVOS_ANULACION
} from '../constants';

const AnulacionForm = ({ confirmar, cancelar, loading, ...props }) => {
  const { Option } = Select;
  const [form] = Form.useForm();
  const otrosMotivosSelected = Form.useWatch('option', form);
  return (
    <Form form={form} layout="vertical" onFinish={confirmar} {...props}>
      <Form.Item
        label="Selecciona un motivo"
        name="option"
        rules={[
          {
            required: true,
            message: '¡Seleccione un motivo!'
          }
        ]}
      >
        <Select style={{ width: '100%' }} placeholder="Seleccione una opción">
          {MOTIVO_ANULACION_SELECT.map(({ descripcion, codigo }) => (
            <Option key={descripcion} value={codigo}>
              {descripcion}
            </Option>
          ))}
        </Select>
      </Form.Item>
      {otrosMotivosSelected === 'OTROS_MOTIVOS' && (
        <Form.Item
          label={OTROS_MOTIVOS_ANULACION.descripcion}
          name={OTROS_MOTIVOS_ANULACION.codigo}
          rules={[
            {
              required: true,
              message: '¡Detalle el motivo!'
            }
          ]}
        >
          <Input.TextArea
            placeholder="Ingrese texto aquí"
            style={{ marginTop: 10 }}
            autoSize={{ minRows: 3 }}
          />
        </Form.Item>
      )}
      <Form.Item
        label={COMENTARIOS_ADICIONALES_ANULACION.descripcion}
        name={COMENTARIOS_ADICIONALES_ANULACION.codigo}
      >
        <Input.TextArea
          placeholder="Ingrese texto aquí"
          style={{ marginTop: 10 }}
          autoSize={{ minRows: 3 }}
        />
      </Form.Item>

      <Form.Item>
        <Space size="large">
          <Button key="back" onClick={() => cancelar(false)}>
            Cancelar
          </Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            Confirmar anulación
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default AnulacionForm;
